export let HOST = process.env.NODE_ENV === 'development' ? "https://hapihapi.fun/api/v1" : "https://hapihapi.fun/api/v1";
if (0) {HOST = 'http://localhost:4001/v1'}

export const SIGN_ID = `${HOST}/sign/:id`;
